export default {"src":"/_next/static/media/cardio.ab36cb88.svg","height":683,"width":683,"blurWidth":0,"blurHeight":0};